<template>
  <div>
    <b-modal
      id="crew-modal"
      modal-class="guide-modal"
      hide-footer
      hide-header
      centered
      visible
    >
      <!-- scrollable -->
      <!--Crew  -->

      <template v-if="active == 'engine'">
        <div class="header__crew">
          <h2>Engines</h2>
          <div class="ico__header">
            <span
              class="ico ico__back"
              v-b-tooltip.hover
              title="Go back"
              @click="closeMe"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
                <path
                  d="M28 18H8M8 18L16 10M8 18L16 26"
                  stroke="#606770"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </span>
            <span></span>
            <span
              class="ico ico__add"
              @click="active = 'add'"
              v-b-tooltip.hover
              title="New Engine"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 0V24" stroke="#8D99A0" stroke-width="2" />
                <path d="M0 12L24 12" stroke="#8D99A0" stroke-width="2" />
              </svg>
            </span>
            <span
              class="ico ico__search"
              v-b-tooltip.hover
              title="Search"
              @click="active = 'search'"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.85406 19.7087C4.39643 19.7087 0 15.3122 0 9.85437C0 4.39656 4.39643 0 9.85406 0C15.3117 0 19.7081 4.39656 19.7081 9.85437C19.7081 15.3122 15.3117 19.7087 9.85406 19.7087ZM9.85406 1.51606C5.23023 1.51606 1.51601 5.2304 1.51601 9.85437C1.51601 14.4783 5.23023 18.1927 9.85406 18.1927C14.4779 18.1927 18.1921 14.4783 18.1921 9.85437C18.1921 5.2304 14.4779 1.51606 9.85406 1.51606Z"
                  fill="black"
                  fill-opacity="0.5"
                />
                <path
                  d="M17.1932 16.1211L24 22.9282L22.9282 24L16.1213 17.1929L17.1932 16.1211Z"
                  fill="black"
                  fill-opacity="0.5"
                />
              </svg>
            </span>
          </div>
        </div>
        <div class="body__crew">
          <div class="list-wraper">
            <div
              class="list"
              v-for="(engine, i) in engines"
              @click="handleEngineToggle(engine, i)"
              :key="i"
              :class="{ active: activeEngines.indexOf(engine.text) >= 0 }"
            >
              <div class="profile-info">
                <h4>{{ engine.text }}</h4>
                <div class="days">
                  <div class="day" v-for="(when, i) in engine.when" :key="i">
                    {{ when }}
                  </div>
                </div>
              </div>
              <div class="right-time">
                <div class="icons">
                  <span
                    @click="editEngine(engine, i)"
                    class="ico mr-3"
                    v-b-tooltip.hover
                    title="Edit Engine"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.66667 3.33333C2.48986 3.33333 2.32029 3.40357 2.19527 3.5286C2.07024 3.65362 2.00001 3.82319 2.00001 4V13.3333C2.00001 13.5101 2.07024 13.6797 2.19527 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V9.77333C12.6667 9.40514 12.9651 9.10667 13.3333 9.10667C13.7015 9.10667 14 9.40514 14 9.77333V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66667C2.13624 15.3333 1.62753 15.1226 1.25246 14.7475C0.877385 14.3725 0.666672 13.8638 0.666672 13.3333V4C0.666672 3.46957 0.877385 2.96086 1.25246 2.58579C1.62753 2.21071 2.13624 2 2.66667 2H6.22667C6.59486 2 6.89334 2.29848 6.89334 2.66667C6.89334 3.03486 6.59486 3.33333 6.22667 3.33333H2.66667Z"
                        fill="var(--theme-color)"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.5286 0.862254C11.7889 0.601905 12.2111 0.601905 12.4714 0.862254L15.1381 3.52892C15.3984 3.78927 15.3984 4.21138 15.1381 4.47173L8.47141 11.1384C8.34639 11.2634 8.17682 11.3337 8 11.3337H5.33334C4.96515 11.3337 4.66667 11.0352 4.66667 10.667V8.00033C4.66667 7.82351 4.73691 7.65394 4.86193 7.52892L11.5286 0.862254ZM6.00001 8.27647V10.0003H7.72386L13.7239 4.00033L12 2.27647L6.00001 8.27647Z"
                        fill="var(--theme-color)"
                      />
                    </svg>
                  </span>
                  <span
                    class="ico"
                    v-if="!(activeEngines.indexOf(engine.text) >= 0)"
                    v-b-tooltip.hover
                    title="Add Engine"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="var(--theme-color)"
                        fill-opacity="0.1"
                      />
                      <path
                        d="M12.0002 5.14282V18.8571"
                        stroke="var(--theme-color)"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        d="M5.14282 12.0002L18.8571 12.0002"
                        stroke="var(--theme-color)"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <span class="ico" v-else>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                      <path
                        d="M4 13.875L8.09091 18L19 7"
                        stroke="var(--theme-color)"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                </div>

                <span class=""> at {{ engine.time }} </span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- /crew -->
      <!-- Add Crew  -->
      <template v-if="active == 'add' || active == 'edit'">
        <div class="header__crew">
          <h2 v-if="active == 'add'">Add Engine</h2>
          <h2 v-if="active == 'edit'">Edit Engine</h2>
          <div class="ico__header">
            <span
              class="ico ico__back"
              @click="goToEngines"
              v-b-tooltip.hover
              title="Go back"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
                <path
                  d="M28 18H8M8 18L16 10M8 18L16 26"
                  stroke="#606770"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </span>
            <span></span>
            <span> </span>
            <span> </span>
          </div>
        </div>
        <div class="body__crew">
          <div class="add-wraper">
            <div class="your-engine">
              <p>What needs to be done to make this happen?</p>

              <textarea
                rows="5"
                v-model="newEngine.title"
                placeholder="Enter your engine"
                autofocus
              ></textarea>
              <div class="selections">
                <div class="days">
                  <div
                    class="now"
                    @click="makeActive('now')"
                    :class="{ active: repeats.includes('now') }"
                  >
                    Now
                  </div>
                  <div
                    class="day"
                    v-for="(day, i) in days"
                    :key="i"
                    @click="makeActive(day)"
                    :class="{ active: repeats.includes(day) }"
                  >
                    {{ day }}
                  </div>
                </div>

                <div class="calendar" @click="$bvModal.show('calendar-modal')">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.8125 1.875H3.9375V0H5.8125V1.875H18.1875V0H20.0625V1.875H21.1875C22.7383 1.875 24 3.13669 24 4.6875V21.1875C24 22.7383 22.7383 24 21.1875 24H2.8125C1.26169 24 0 22.7383 0 21.1875V4.6875C0 3.13669 1.26169 1.875 2.8125 1.875ZM1.875 21.1875C1.875 21.7044 2.29556 22.125 2.8125 22.125H21.1875C21.7044 22.125 22.125 21.7044 22.125 21.1875V8.8125H1.875V21.1875ZM1.875 6.9375H22.125V4.6875C22.125 4.17056 21.7044 3.75 21.1875 3.75H20.0625V5.625H18.1875V3.75H5.8125V5.625H3.9375V3.75H2.8125C2.29556 3.75 1.875 4.17056 1.875 4.6875V6.9375Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M18.5625 10.7812H20.4375V12.6562H18.5625V10.7812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M14.8125 10.7812H16.6875V12.6562H14.8125V10.7812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M11.0625 10.7812H12.9375V12.6562H11.0625V10.7812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M7.3125 10.7812H9.1875V12.6562H7.3125V10.7812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M3.5625 10.7812H5.4375V12.6562H3.5625V10.7812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M18.5625 14.5312H20.4375V16.4062H18.5625V14.5312Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M14.8125 14.5312H16.6875V16.4062H14.8125V14.5312Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M11.0625 14.5312H12.9375V16.4062H11.0625V14.5312Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M7.3125 14.5312H9.1875V16.4062H7.3125V14.5312Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M18.5625 18.2812H20.4375V20.1562H18.5625V18.2812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M14.8125 18.2812H16.6875V20.1562H14.8125V18.2812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M11.0625 18.2812H12.9375V20.1562H11.0625V18.2812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M7.3125 18.2812H9.1875V20.1562H7.3125V18.2812Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M3.5625 14.5312H5.4375V16.4062H3.5625V14.5312Z"
                      fill="#CBCBCB"
                    />
                  </svg>
                </div>
                <div class="time">
                  <span @click="show.timeSelector = !show.timeSelector">
                    {{ compHours + ":" + compMins + " " + newEngine.period }}
                    <div class="ico">
                      <svg
                        width="7"
                        height="5"
                        viewBox="0 0 7 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L3.5 4L6 1"
                          stroke="#5B606C"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                  </span>

                  <div class="time-selector" v-if="show.timeSelector">
                    <div class="time-input">
                      {{ compHours + ":" + compMins + " " + newEngine.period }}
                    </div>
                    <div class="select__time">
                      <div class="wraper__time">
                        <span
                          class="ico ico-up"
                          @click="newEngine.hour < 12 ? newEngine.hour++ : ''"
                        >
                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                              fill="#474D52"
                            />
                          </svg>
                        </span>
                        <span class="time-digit">
                          <input
                            type="number"
                            min="01"
                            max="12"
                            value="12"
                            v-model="newEngine.hour"
                          />
                        </span>
                        <span
                          class="ico ico-down"
                          @click="newEngine.hour > 1 ? newEngine.hour-- : ''"
                        >
                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                              fill="#474D52"
                            />
                          </svg>
                        </span>
                      </div>
                      <div class="ico ico-colon">
                        <svg
                          width="8"
                          height="32"
                          viewBox="0 0 8 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z"
                            fill="#474D52"
                          />
                          <path
                            d="M4 32C6.20914 32 8 30.2091 8 28C8 25.7909 6.20914 24 4 24C1.79086 24 0 25.7909 0 28C0 30.2091 1.79086 32 4 32Z"
                            fill="#474D52"
                          />
                        </svg>
                      </div>
                      <div class="wraper__time">
                        <span
                          class="ico ico-up"
                          @click="newEngine.mins < 60 ? newEngine.mins++ : ''"
                        >
                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                              fill="#474D52"
                            />
                          </svg>
                        </span>
                        <span class="time-digit">
                          <input
                            type="number"
                            min="00"
                            max="60"
                            value="00"
                            v-model="newEngine.mins"
                          />
                        </span>
                        <span
                          class="ico ico-down"
                          @click="newEngine.mins > 0 ? newEngine.mins-- : ''"
                        >
                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                              fill="#474D52"
                            />
                          </svg>
                        </span>
                      </div>
                      <div class="wraper__time">
                        <span
                          class="ico ico-up"
                          @click="newEngine.period = 'AM'"
                        >
                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                              fill="#474D52"
                            />
                          </svg>
                        </span>
                        <span class="time-digit">
                          {{ newEngine.period }}
                        </span>
                        <span
                          class="ico ico-down"
                          @click="newEngine.period = 'PM'"
                        >
                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                              fill="#474D52"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span></span>
            <button
              class="btn-add-crew"
              @click="addEngine"
              v-if="active == 'add'"
            >
              Add New Engine
            </button>
            <button
              class="btn-add-crew"
              @click="updateEngine"
              v-if="active == 'edit'"
            >
              Update Engine
            </button>
          </div>
        </div>
      </template>
      <!-- /add-crew -->
      <!--Crew  -->
      <template v-if="active == 'search'">
        <div class="header__crew header__search">
          <input
            type="search"
            v-model="searchStr"
            class="search"
            placeholder="Search"
            ref="searchfield"
          />
          <div class="ico" @click="hideSearch">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="14.2222"
                    height="14.2222"
                    fill="white"
                    transform="translate(8.88867 8.88867)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="body__crew">
          <div class="list-wraper">
            <div
              class="list"
              v-for="(engine, i) in filteredEngines"
              :key="i"
              @click="editEngine(engine, i)"
            >
              <div class="profile-info">
                <h4>{{ engine.text }}</h4>
                <div class="days">
                  <div class="day" v-for="(repeat, i) in engine.when" :key="i">
                    {{ repeat }}
                  </div>
                </div>
              </div>
              <div class="right-time">
                <span class=""> at {{ engine.time }} </span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- /crew -->
    </b-modal>
    <Calendar
      v-if="show.calendar"
      @closeMe="show.calendar = false"
      @updateDate="dateTimeUpdated"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Calendar from "@/components/common/calendar";
export default {
  props: ["oldEngines", "addedEgines"],
  data() {
    return {
      show: {
        timeSelector: false,
        calendar: true
      },
      engines: [],
      myEngines: [],
      activeEngines: [],
      searchStr: "",
      active: "engine",
      newEngine: {
        title: "",
        hour: "12",
        mins: "00",
        period: "AM"
      },
      days: ["Su", "M", "Tu", "W", "Th", "F", "Sa"],
      editIndex: -1,
      repeats: []
    };
  },
  mounted() {
    if (this.oldEngines.length == 0 && this.addedEgines.length == 0) {
      // if (this.enginesList.length > 0) {
      //   this.engines = [...this.enginesList, ...this.engines];
      // }
      this.engines = [];
    } else if (this.addedEgines.length !== 0) {
      this.engines = this.addedEgines;
    }
    if (this.oldEngines) {
      this.oldEngines.forEach(engine => {
        this.myEngines.push(engine);
        this.activeEngines.push(engine.text);
      });
    }
  },
  watch: {
    active(newv, oldv) {
      if (newv == "search") {
        // this.$refs.search.focus();
        setTimeout(() => {
          document.querySelector(".search").focus();
        }, 100);
      }
    }
  },
  components: {
    Calendar
  },
  computed: {
    ...mapGetters({
      enginesList: "user/listEngine"
    }),
    filteredEngines() {
      if (this.searchStr.trim() == "") return this.engines;

      return this.engines.filter(cr => {
        return cr.text
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
      });
    },
    compHours() {
      if (this.newEngine.hour < 10) {
        if (this.newEngine.hour == "0" || this.newEngine.hour[0] != "0")
          return "0" + this.newEngine.hour;
        else {
          return this.newEngine.hour;
        }
      }
      return this.newEngine.hour;
    },
    compMins() {
      let mins = parseInt(this.newEngine.mins);
      if (mins < 10) {
        return "0" + this.newEngine.mins;
      } else {
        return this.newEngine.mins;
      }
    }
  },
  filters: {
    highlight(stringToSearch, searchTerm) {
      if (searchTerm === "") return stringToSearch;
      var iQuery = new RegExp(searchTerm, "ig");
      return stringToSearch
        .toString()
        .replace(iQuery, function(matchedText, a, b) {
          return "<span style='font-weight: 800'>" + matchedText + "</span>";
        });
    }
  },
  methods: {
    handleEngineToggle(engine, index) {
      let current_index = this.activeEngines.indexOf(engine.text);
      if (current_index >= 0) {
        this.myEngines.splice(current_index, 1);
        this.activeEngines.splice(current_index, 1);
      } else {
        this.myEngines.push(engine);
        this.activeEngines.push(engine.text);
      }
    },
    dateTimeUpdated(dateTime) {
      console.log(dateTime.date.format, dateTime.time);
      this.show.calendar = false;
    },
    makeActive(day) {
      if (this.repeats.includes(day)) {
        this.repeats.splice(this.repeats.indexOf(day), 1);
        console.log(this.repeats.includes(day));
      } else {
        this.repeats.push(day);
      }
      console.log(day);
      console.log(this.repeats);
    },
    hideSearch() {
      this.active = "engine";
      this.searchStr = "";
    },
    editEngine(engine, index) {
      this.newEngine.title = this.engines[index].text;

      this.newEngine.hour = this.engines[index].time.split(":")[0];
      this.newEngine.mins = this.engines[index].time
        .split(":")[1]
        .split(" ")[0];
      this.newEngine.period = this.engines[index].time
        .split(":")[1]
        .split(" ")[1];
      this.repeats = this.engines[index].when;
      this.editIndex = index;
      this.active = "edit";
    },
    // updateSearch() {
    //   return this.engines.forEach((cr) => {
    //     // cr.name.replace(new RegExp(this.searchStr, "gi"), (match) => {
    //     //   return '<span class="highlightText">' + match + "</span>";
    //     // });
    //     // cr.name=`<span>${cr.name}</span>`
    //     return cr.name.replace(
    //       "/sa/g",
    //       '<span class="highlight">' + this.searchStr + "</span>"
    //     );
    //   });
    // },

    addEngine() {
      let engine = {
        _created_at: new Date(),
        text: this.newEngine.title,
        when: this.repeats,
        time: this.compHours + ":" + this.compMins + " " + this.newEngine.period
      };
      this.engines.unshift(engine);
      this.myEngines.push(engine);
      this.activeEngines.push(engine.text);
      this.reset();
    },
    updateEngine() {
      this.engines[this.editIndex].text = this.newEngine.title;
      this.newEngine.time =
        this.newEngine.hour +
        "" +
        this.newEngine.mins +
        " " +
        this.newEngine.period;

      this.engines[this.editIndex].when = this.repeats;

      this.reset();
    },
    reset() {
      this.show.timeSelector = false;
      this.newEngine.title = "";
      this.newEngine.hour = "12";
      this.newEngine.mins = "0";
      this.newEngine.period = "AM";
      this.repeats = [];

      this.active = "engine";
    },
    goToEngines() {
      if (this.active == "edit") {
        this.reset();
      }
      this.active = "engine";
    },
    closeMe() {
      this.$emit("closeMe", { active: this.myEngines, all: this.engines });
      this.show.engines = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.your-engine {
  //  z-index: 2;
  padding: 15px;
  width: 100%;
  // position: absolute;
  // top: 0;
  // left: 0;
  //   height: 337px;
  // box-shadow: 2px 2px 40px rgba(33, 24, 86, 0.09);
  border-radius: 5px;
  // background-color: #fff;
  textarea {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 22px;
    width: 100%;
    resize: none;
    color: #5b606c;
    border: none;
    padding: 12px 24px;
  }
  .title {
    position: relative;
    .icon {
      position: absolute;
      left: 10px;
      top: 0px;
      cursor: pointer;
    }
    h4 {
      text-align: center;
      // display: inline;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      /* identical to box height */

      text-align: center;

      color: #5b606c;
    }
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
  }
  .new-engines {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
    }
    .right {
      display: flex;
      justify-content: center;
      h5 {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        text-align: right;
        color: #8d99a0;
      }
      .ico {
        margin-left: 20px;
      }
    }
  }
  textarea {
    font-family: Nunito;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */
    width: 100%;
    resize: none;
    color: #5b606c;
  }
  .selections {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    .time {
      background-color: #f3f6f9;
      width: 108px;
      border-radius: 10px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #5b606c;
      position: relative;
      transition: all 0.2s ease-in-out;
      svg {
        //  fill: ;
      }
      &:hover,
      &:active {
        background: var(--theme-color);
        span {
          color: #fff;
          fill: #fff !important;
        }
      }
      & > span {
        cursor: pointer;
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        // align-items: center;
        align-items: center;
      }
      .time-selector {
        position: absolute;
        top: 100%;
        right: 0%;
        background-color: #fff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        padding: 8px;
        * {
          user-select: none; /* standard syntax */
          -webkit-user-select: none; /* webkit (safari, chrome) browsers */
          -moz-user-select: none; /* mozilla browsers */
          -khtml-user-select: none; /* webkit (konqueror) browsers */
          -ms-user-select: none; /* IE10+ */
        }
        .time-input {
          // input {
          background: #ffffff;
          border-radius: 32px;
          border: 1px solid #ddd;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 7px;
          margin: 4px 0;
          h5 {
            font-family: "Nunito", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #474d52;
            margin: 0;
          }
          // }
        }
        .select__time {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .wraper__time {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          border: 1px solid #dddddd;
          box-sizing: border-box;
          border-radius: 4px;
          margin: 0px 3px;
          span {
            height: 30px;
            width: 45px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            &.ico-up {
              &:after {
                content: "";
                width: 90%;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                position: absolute;
                border-bottom: 1px solid #dddddd;
              }
            }
            &.ico-down {
              &:after {
                content: "";
                width: 90%;
                left: 50%;
                transform: translateX(-50%);
                top: 0;
                position: absolute;
                border-bottom: 1px solid #dddddd;
              }
            }
            &.time-digit {
              height: 33px;
              color: #474d52 !important;
              input {
                border: none;
                text-align: center;
                &:focus {
                  outline: none;
                }
              }
              input::-webkit-outer-spin-button,
              input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }

              /* Firefox */
              input[type="number"] {
                -moz-appearance: textfield;
              }
            }
          }
        }
      }
    }
    .days {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .day,
      .now {
        width: 50px;
        height: 29px;
        background: #f3f6f9;
        border-radius: 1000px;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8d99a0;
        cursor: pointer;
        margin: 0 2px;
        transition: all 0.2s ease-in-out;
        &:hover,
        &.active {
          background: var(--theme-color);
          color: #fff;
        }
      }
      .day {
        width: 29px;
        height: 29px;
        border-radius: 50%;
      }
    }
  }
}
#crew-modal {
  .ico {
    cursor: pointer;
  }
  .header__crew {
    position: relative;
    padding-bottom: 16px;
    h2 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;
      color: #5b606c;
      margin: 0;
    }
    .ico__header {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 35px 1fr 40px 60px;
      align-items: center;
      justify-items: flex-end;
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-bottom: 1px solid #ddd;
    }
  }
  .body__crew {
    .list-wraper {
      display: flex;
      //   justify-content: center;
      align-items: center;
      flex-direction: column;
      max-height: 600px;
      overflow-y: scroll;
      padding: 12px 12px;
      &::-webkit-scrollbar {
        width: 5px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
      }
      .day {
        width: 29px;
        height: 29px;
        background: #f3f6f9;
        border-radius: 1000px;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8d99a0;
        cursor: pointer;
        margin: 0 2px;
        transition: all 0.2s ease-in-out;
      }
      .list {
        height: 98px;
        cursor: pointer;
        width: 100%;
        padding: 16px;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 4px 0;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        &.active {
          background: rgba(85, 126, 251, 0.1);
        }

        h5,
        h4 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin-bottom: 12px;
          .highlight {
            font-weight: 800;
          }
        }
        h5 {
          font-size: 12px;
          line-height: 16px;
          margin: 0;
        }

        .profile-info {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          .days {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
        }
        .right-time {
          display: flex;
          align-items: flex-end;
          flex-direction: column;
          .icons {
            margin-bottom: 20px;
          }
          .ico {
            width: fit-content;

            cursor: pointer;
            margin-bottom: 12px;
          }
        }
      }
    }
    .add-wraper {
      display: grid;
      grid-template-rows: 1fr 1fr 100px;
    }
    //   label {
    //     font-style: normal;
    //     font-weight: normal;
    //     font-size: 16px;
    //     line-height: 22px;
    //     display: flex;
    //     align-items: center;
    //     color: #474d52;
    //     margin-top: 25px;
    //   }
    //   input {
    //     border: none;
    //     &:focus {
    //       box-shadow: none;
    //     }
    //   }
    // }
  }
  .header__search {
    display: flex;
    align-items: center;
    input {
      border: none;
      padding: 5px 10px;
      width: 100%;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      //   text-align: center;
      color: #5b606c;
    }
  }
}
</style>
